var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "secure-payment-fill-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.518,
    height: 46.518,
    viewBox: "0 0 46.518 46.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26516",
    "data-name": "Path 26516",
    d: "M0,0H46.518V46.518H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26517",
    "data-name": "Path 26517",
    d: "M18.506,2,32.651,6.419A1.938,1.938,0,0,1,34.012,8.27v3.421h3.876a1.938,1.938,0,0,1,1.938,1.938v3.876h-25.2V13.629a1.938,1.938,0,0,1,1.938-1.938H30.135v-2L18.506,6.059,6.876,9.695V24.046A7.754,7.754,0,0,0,9.9,30.189l.365.262,8.243,5.623,7.33-5H16.568a1.938,1.938,0,0,1-1.938-1.938V21.382h25.2v7.753a1.938,1.938,0,0,1-1.938,1.938l-6.241,0a11.606,11.606,0,0,1-2.714,2.578L18.506,40.765,8.078,33.655A11.629,11.629,0,0,1,3,24.046V8.27A1.938,1.938,0,0,1,4.361,6.421Z",
    transform: "translate(2.815 1.876)",
    fill: "#b1d5d5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.cd5bbf0b8b16a7ce3c85d3ed5771a965.svg";
export { ForwardRef as ReactComponent };